export const Provider = Object.freeze({
    MySql:1,
    SqlServer: 2
  });